module.exports = __webpack_public_path__ + "static/2-THE-RISE-OF-THE-DIGITAL-WORKPLACE-c4661305a28757954d91ed1227bdcdf3.png";